import { supabase } from '@/shared/lib/supabase/client';
import { AppError } from '@/shared/lib/repository/errors';
import type { SubscriberStatus } from '@/shared/types/tables';

/**
 * Newsletter double opt-in. All three calls are SECURITY DEFINER RPCs: subscriber
 * rows are admin-read-only, so confirmation tokens never reach the browser — they
 * travel by email and come back through `confirm_subscription`.
 */
export const newsletterRepository = {
  async subscribe(email: string): Promise<SubscriberStatus> {
    const { data, error } = await supabase.rpc('subscribe_email', { p_email: email });
    if (error) throw new AppError(error.message, error.code, error);
    return data;
  },

  async confirm(token: string): Promise<boolean> {
    const { data, error } = await supabase.rpc('confirm_subscription', { p_token: token });
    if (error) throw new AppError(error.message, error.code, error);
    return data;
  },

  async unsubscribe(token: string): Promise<boolean> {
    const { data, error } = await supabase.rpc('unsubscribe_by_token', { p_token: token });
    if (error) throw new AppError(error.message, error.code, error);
    return data;
  },
};
